import { toInteger, toString, trim } from 'lodash';
import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import i18n from 'i18n';
import { parseError } from 'helpers/Error';
import { DISPENSING_SYSTEM } from 'app/main/pharmacy/constants';
import { arrayToObject } from 'app/utils/Utils';
import { parseDataToModel } from './update.actions';
import { startDispenseSyncJobPolling } from '../../utils/dispenseSyncJobPolling';

const DISPENSING_SYSTEM_VALUE = arrayToObject(DISPENSING_SYSTEM, 'value');

export const CREATE_PATIENT_GROUP = '@PATIENT_GROUP/CREATE_PATIENT_GROUP';
export const CREATE_PATIENT_GROUP_SUCCESS = '@PATIENT_GROUP/CREATE_PATIENT_GROUP_SUCCESS';
export const CREATE_PATIENT_GROUP_FAIL = '@PATIENT_GROUP/CREATE_PATIENT_GROUP_FAIL';

export const CHANGE_PATIENT_GROUP_CREATE_FORM = '@PATIENT_GROUP/CHANGE_PATIENT_GROUP_CREATE_FORM';

export const CLEAR_CREATE_FORM = '@PATIENT_GROUP/CLEAR_CREATE_FORM';

export function confirmCreatePatientGroup() {
  return (dispatch, getState) => {
    const { data } = getState().patientGroup.create;
    const authUser = getState().auth.user;
    const dispenseCode = trim(data?.dispenseCode || '');
    const isFDPlus = toString(authUser?.dispensingSystem) === DISPENSING_SYSTEM_VALUE['13'].value;

    if (!isFDPlus || !dispenseCode) {
      dispatch(createPatientGroup({ runDispenseSyncImmediately: false }));
      return;
    }

    dispatch(
      AppActions.createDialogMessage(
        'info',
        i18n.t('patientGroup:CREATE_RUN_DISPENSE_SYNC_CONFIRM_TITLE'),
        i18n.t('patientGroup:CREATE_RUN_DISPENSE_SYNC_CONFIRM_MESSAGE'),
        {
          dialogId: 'PATIENT_GROUP_CREATE_RUN_DISPENSE_SYNC',
          options: {
            buttons: [
              {
                label: i18n.t('NO'),
              },
              {
                label: i18n.t('YES'),
                color: 'primary',
                variant: 'contained',
              },
            ],
          },
          callback: (label) => {
            const runDispenseSyncImmediately = label === i18n.t('YES');
            dispatch(createPatientGroup({ runDispenseSyncImmediately }));
            dispatch(AppActions.closeDialogMessage('PATIENT_GROUP_CREATE_RUN_DISPENSE_SYNC'));
          },
        },
      ),
    );
  };
}

export function createPatientGroup({ runDispenseSyncImmediately = false } = {}) {
  return (dispatch, getState) => {
    const { data } = getState().patientGroup.create;
    dispatch({ type: CREATE_PATIENT_GROUP });
    const postData = {
      ...parseDataToModel(data),
      runDispenseSyncImmediately: Boolean(runDispenseSyncImmediately),
    };

    HttpService.post(`api/patientGroups`, postData)
      .then((resp) => {
        const jobId = resp?.dispenseSyncJobId || resp?.DispenseSyncJobId;
        dispatch(
          AppActions.showMessage({
            message: i18n.t('Patient group has been added successfully'),
          }),
        );
        dispatch({ type: CREATE_PATIENT_GROUP_SUCCESS, payload: { patientGroupId: resp.data.id } });

        if (jobId) {
          // Keep poll alive for list Run Sync label; UI updates only on the sync button row.
          startDispenseSyncJobPolling({ jobId, intervalMs: 5000 });
        }
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({
          type: CREATE_PATIENT_GROUP_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', 'Warning', errorMessages));
      });
  };
}

export function clearCreateForm() {
  return (dispatch) => {
    dispatch({ type: CLEAR_CREATE_FORM });
  };
}

export function changePatientGroupCreateForm(data) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PATIENT_GROUP_CREATE_FORM, payload: { data: { ...data, beds: toInteger(data.beds) } } });
  };
}
